export default __webpack_public_path__ + "static/media/Light_Green_Rect.3b832ca7.png";